module.exports = __webpack_public_path__ + "media/img/logos/2024/jobboerse-stellenangebote-berufseinsteiger-frauentag-0d6fddf18a4552c16d7f4c449c370685.svg";